/** Cardinal headings. Grid y grows downward (screen space), so North is y - 1. */
export const Dir = { N: 0, E: 1, S: 2, W: 3 } as const;
export type Direction = (typeof Dir)[keyof typeof Dir];

export const DIRECTIONS: readonly Direction[] = [Dir.N, Dir.E, Dir.S, Dir.W];

const DX: readonly number[] = [0, 1, 0, -1];
const DY: readonly number[] = [-1, 0, 1, 0];

export function dx(dir: Direction): number {
  return DX[dir] as number;
}

export function dy(dir: Direction): number {
  return DY[dir] as number;
}

export function turnLeft(dir: Direction): Direction {
  return ((dir + 3) % 4) as Direction;
}

export function turnRight(dir: Direction): Direction {
  return ((dir + 1) % 4) as Direction;
}

export function opposite(dir: Direction): Direction {
  return ((dir + 2) % 4) as Direction;
}

/** A change of heading relative to the current one. */
export type Turn = 'left' | 'right' | 'reverse';

export function applyTurn(dir: Direction, turn: Turn): Direction {
  switch (turn) {
    case 'left':
      return turnLeft(dir);
    case 'right':
      return turnRight(dir);
    case 'reverse':
      return opposite(dir);
  }
}

/** The relative turn that takes `from` to `to`, or null when they are the same heading. */
export function turnBetween(from: Direction, to: Direction): Turn | null {
  switch ((to - from + 4) % 4) {
    case 1:
      return 'right';
    case 2:
      return 'reverse';
    case 3:
      return 'left';
    default:
      return null;
  }
}

export function isDirection(value: unknown): value is Direction {
  return value === 0 || value === 1 || value === 2 || value === 3;
}
